import * as ng from 'angular';

export default (module: ng.IModule) => {
    module.directive('tyFileDropzone', fileDropzoneFactory);
};

const noPropagation = function (e: Event) {
    e.stopPropagation();
    e.preventDefault();
};

const onEnterZone = (el: DocumentAndElementEventHandlers, listener: EventListener) => {
    ['dragenter', 'dragover'].forEach((eventName) => {
        el.addEventListener(eventName, listener);
    });
};

const onLeaveZone = (el: DocumentAndElementEventHandlers, listener: EventListener) => {
    ['dragleave'].forEach((eventName) => {
        el.addEventListener(eventName, listener);
    });
};

function fileDropzoneFactory(): ng.IDirective {
    const CSS_HIGHLIGHT_CLASS = 'ty-dropzone-highlight';

    return {
        restrict: 'A',
        link,
    };

    function link(scope: ng.IScope, $element: ng.IAugmentedJQuery, attributes: ng.IAttributes) {
        // get "raw" DOM element
        const dropzoneEl = $element.get(0);

        onEnterZone(dropzoneEl, (e: Event) => {
            noPropagation(e);
            dropzoneEl.classList.add(CSS_HIGHLIGHT_CLASS);
        });

        // When listening to "leave" events, all children of the element we are listening on will emit this event.
        // This means we will get multiple "leave" events, even tough we are still inside the drop zone.
        //
        // In order to properly handle a "leave" event, we have to look at all leave events from `document` perspective
        // and check if the "leaving" target is a child of our designated listener parent.
        onLeaveZone(document, (e: Event) => {
            noPropagation(e);
            if (dropzoneEl.contains(e.target as Node)) return; // we are still inside the dropzone...
            dropzoneEl.classList.remove(CSS_HIGHLIGHT_CLASS);
        });

        dropzoneEl.addEventListener('drop', (event) => {
            noPropagation(event);
            // files were dropped, remove the highlight
            dropzoneEl.classList.remove(CSS_HIGHLIGHT_CLASS);
            const files = Array.from(event.dataTransfer?.files ?? []);
            // call handler function assigned to directive
            scope.$eval(attributes.tyFileDropzone, { $files: files });
        });
    }
}
